import DefaultFactory from "/scripts/default/factory";
import SvgHero from "/components/svg/hero";
import SvgMorph from "/components/svg/morph";
import SvgDrag from "/components/svg/drag";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class SvgFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "svg-hero":
				return new SvgHero(block);
			case "svg-morph":
				return new SvgMorph(block);
			case "svg-drag":
				return new SvgDrag(block);
			case "svg-drag":
				return new SvgDrag(block);
			default:
				return null;
		}
	}
}

new SvgFactory();
